import React from "react";
import { useDispatch } from "react-redux";
import { BsDash, BsPlus } from "react-icons/bs";
import { OnestNormalDefault, OnestSemiBoldDefault } from "../../components/styled/TextComponents";
import { useWindowDimensions } from "../../utils";
import { color_red_default, color_white, color_grey_dark } from "../../constants/colors";
import { useI18n } from "../../i18n/I18nProvider";

const FaqQuestion = ({ question, onChangeFaqQuestionClickButton }) => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
   
    const handleChangeFaqQuestionClickButton = React.useCallback(() => {
        onChangeFaqQuestionClickButton(question);
    }, [onChangeFaqQuestionClickButton, question]);

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
        }}>
            <div style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
            }}>
                <div style={{ width: screenWidth > 610 ? 520 : screenWidth - 170 }}>
                    <OnestSemiBoldDefault>{t(question.question)}</OnestSemiBoldDefault>
                </div>
                <div style={{
                    width: 25,
                    height: 25,
                    minWidth: 25,
                    minHeight: 25,
                    borderRadius: "50%",
                    backgroundColor: color_red_default,
                    color: color_white,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
                    onClick={handleChangeFaqQuestionClickButton}
                >
                    {question.active ? <BsDash /> : <BsPlus />}
                </div>
            </div>
            {question.active &&
                <div>
                    <OnestNormalDefault style={{ color: color_grey_dark }}>{t(question.answer)}</OnestNormalDefault>
                </div>
            }
        </div>
    );
};

export default FaqQuestion;